import { render, staticRenderFns } from "./answer-layer.vue?vue&type=template&id=7e645296&"
import script from "./answer-layer.vue?vue&type=script&lang=js&"
export * from "./answer-layer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports